import type { Transition, Variants } from "motion/react";

/** Shared motion language: quick, soft and physical, never bouncy for its own sake. */
export const spring: Transition = { type: "spring", stiffness: 420, damping: 34, mass: 0.8 };
export const springSoft: Transition = { type: "spring", stiffness: 180, damping: 24 };
export const easeOut = [0.16, 1, 0.3, 1] as const;

export const fadeUp: Variants = {
  hidden: { opacity: 0, y: 14, filter: "blur(6px)" },
  show: { opacity: 1, y: 0, filter: "blur(0px)", transition: { duration: 0.6, ease: easeOut } },
};

export const stagger = (gap = 0.06, delay = 0): Variants => ({
  hidden: {},
  show: { transition: { staggerChildren: gap, delayChildren: delay } },
});

/** Page-level enter and exit. `direction` is +1 when moving forward through steps. */
export const pageSlide: Variants = {
  enter: (direction: number) => ({ opacity: 0, x: direction * 28, filter: "blur(8px)" }),
  center: { opacity: 1, x: 0, filter: "blur(0px)", transition: { duration: 0.55, ease: easeOut } },
  exit: (direction: number) => ({
    opacity: 0,
    x: direction * -20,
    filter: "blur(6px)",
    transition: { duration: 0.25, ease: easeOut },
  }),
};

/** Fade and lift between pages of the app. */
export const pageFade: Variants = {
  enter: { opacity: 0, y: 12, filter: "blur(6px)" },
  center: { opacity: 1, y: 0, filter: "blur(0px)", transition: { duration: 0.5, ease: easeOut } },
  exit: { opacity: 0, y: -8, filter: "blur(4px)", transition: { duration: 0.18, ease: easeOut } },
};
